import { Container, Stack } from '@mui/material'
const SinglePageStack = ({ spacing = 5, maxWidth = 'md', children, ...otherProps }) => (
  <Container maxWidth={maxWidth} {...otherProps}>
    <Stack width='100%' spacing={spacing}>
      {children}
    </Stack>
  </Container>
)
export default SinglePageStack
